// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VehicleCapacityConfigAreaId } from './VehicleCapacityConfigAreaId'
import {
  VehicleCapacityConfigAreaNavigation,
  VehicleCapacityConfigAreaNavigationIcon,
} from './VehicleCapacityConfigAreaNavigation'
import { VehicleCapacityConfigAreaRoutes } from './VehicleCapacityConfigAreaRoutes'

const LazyVehicleCapacityConfigComponent = lazy(
  () => import('./VehicleCapacityConfigArea'),
)

const VehicleCapacityConfigComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleCapacityConfigComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleCapacityConfigArea = {
  id: VehicleCapacityConfigAreaId,
  requiredRight: BoumRight.AREA_VEHICLE_CAPACITY_CONFIG,
  Icon: VehicleCapacityConfigAreaNavigationIcon,
  NavigationComponent: VehicleCapacityConfigAreaNavigation,
  route: {
    path: VehicleCapacityConfigAreaRoutes.route,
    component: VehicleCapacityConfigComponent,
  },
}
